import { Select, Row, Col, Typography } from 'antd';

const { Option } = Select;
const { Text } = Typography;

export const Field = ({ p, val, keyName, placeholder }: any) => (
  <Select
    placeholder={placeholder}
    value={val}
    onChange={(v) => p.handleFieldChange(keyName, v)}
    disabled={p.disabled}
    className="w-full"
    showSearch
    filterOption={p.filterOption}
    allowClear
  >
    {p.fieldOptions.map((option: any) => (
      <Option key={option.value} value={option.value}>
        {option.label}
      </Option>
    ))}
  </Select>
);

export const Header = ({ p, tKey }: any) => (
  <Row gutter={8} align="middle">
    <Col
      span={24}
      className="border border-yellow-300 bg-yellow-50 p-sm rounded"
    >
      <Text className="text-base text-neutral-900">
        {p.t(tKey)}: {p.getReadableFormula(p.currentConfig.type)}
      </Text>
    </Col>
  </Row>
);
